// ─── 데이터 가공 헬퍼 ────────────────────────────────────────────────────────
import { getStoredUserId, readLocalMember } from '@utils/authStorage';
import { qnaApi } from '../../services/qnaApi';

/** React Query 캐시 키 반환 */
export function adminHistoryQueryKey() {
  return ['aiAdmin', 'qaHistory', 'company', getStoredUserId()];
}

/** JSON 문자열 안전 파싱 */
export function parseJson(s, fb = {}) {
  if (!s || typeof s !== 'string') return typeof s === 'object' && s ? s : fb;
  try { return JSON.parse(s); } catch { return fb; }
}

/** chat_time 공백을 T로 교체해 ISO 형식으로 변환 */
export function toIso(chatTime) {
  if (!chatTime) return '';
  return String(chatTime).replace(' ', 'T');
}

/** row의 chat_time을 밀리초 타임스탬프로 반환 */
export function rowTimeMs(row) {
  const t = Date.parse(row.chat_time);
  return Number.isFinite(t) ? t : 0;
}

/** meta_json의 eval_score를 0~100 정규화 */
export function normalizeEval(meta) {
  if (!meta || meta.eval_score == null) return null;
  const n = Number(meta.eval_score);
  if (Number.isNaN(n)) return null;
  if (n >= 0 && n <= 1) return Math.round(n * 100);
  return Math.round(Math.min(100, Math.max(0, n)));
}

/** API 응답 아이템 하나를 UI 행(row) 객체로 변환 */
export function mapHistoryItemToRow(item) {
  const meta = parseJson(item.meta_json, {});
  const refs = parseJson(item.retrieved_refs_json, {});
  const citations = refs.citations || refs.law_refs || [];

  const latency =
    meta.latency_ms != null
      ? Number(meta.latency_ms)
      : meta.perf?.service_total_ms != null
        ? Number(meta.perf.service_total_ms)
        : meta.perf?.total_ms != null
          ? Number(meta.perf.total_ms)
          : null;

  const ls = readLocalMember();
  const uid = String(item.user_id ?? item.userId ?? '').trim();
  let userName    = String(item.user_name    ?? item.userName    ?? '').trim();
  let companyCode = String(item.company_code ?? item.companyCode ?? '').trim();
  let companyName = String(item.company_name ?? item.companyName ?? '').trim();
  const memberDept = String(item.department ?? '').trim();

  if (uid && uid === ls.userId) {
    if (!userName    && ls.name)     userName    = ls.name;
    if (!companyCode && ls.compCode) companyCode = ls.compCode;
    if (!companyName && ls.compName) companyName = ls.compName;
  }

  const rawTime = item.chat_time ?? item.created_at;
  return {
    turn_id:       item.id ?? item.turn_id,
    user_id:       uid,
    user_name:     userName || uid || '—',
    company_code:  companyCode || '—',
    company_name:  companyName || '',
    dept_name:     meta.dept_name || memberDept || '',
    question:      item.question || '',
    answer:        item.answer || null,
    answer_status: String(item.status || item.answer_status || 'error').toLowerCase(),
    chat_time:     toIso(rawTime),
    eval_score:    normalizeEval(meta),
    latency_ms:    latency != null && !Number.isNaN(latency) ? Math.round(latency) : null,
    llm_model:     meta.llm_model || null,
    refs: Array.isArray(citations)
      ? citations.map((c) => ({
          law:     c.title   || c.law     || '',
          article: c.source  || c.article || '',
          snippet: c.snippet || '',
        }))
      : [],
  };
}

/** API에서 전체 이력을 가져와 row 배열로 반환 */
export async function fetchCompanyHistory() {
  const data = await qnaApi.adminHistoryList();
  const list = Array.isArray(data) ? data : [];
  return list.map(mapHistoryItemToRow);
}
